import { render, staticRenderFns } from "./Estimate.vue?vue&type=template&id=15c26dba&scoped=true&"
import script from "./estimate.js?vue&type=script&lang=js&"
export * from "./estimate.js?vue&type=script&lang=js&"
import style0 from "./estimate.scss?vue&type=style&index=0&id=15c26dba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c26dba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c26dba')) {
      api.createRecord('15c26dba', component.options)
    } else {
      api.reload('15c26dba', component.options)
    }
    module.hot.accept("./Estimate.vue?vue&type=template&id=15c26dba&scoped=true&", function () {
      api.rerender('15c26dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Builder/OverviewTab/Estimate.vue"
export default component.exports